module.exports = __webpack_public_path__ + "img/芒果7.9a116ab4.png";